import React, { useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SpeedDial } from 'primereact/speeddial';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { InputText } from 'primereact/inputtext';
import InputTextEmail from "../../../Componentes/InputTextEmail";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

import { Password } from 'primereact/password';
import md5 from "md5";



export default function FormNovoUsuario(props) {
    const {visible, setVisible}  = props
    const [errors, setErrors] = useState({});
    const [tipoCadastro, setTipoCadastro] = useState('juridica'); // Inicializa como 'juridica'
    const {idusuario, Conexao} = props
    const{edicao} =  props;
    const { dataEmpresa } = props;
    const toast = React.useRef(null); // Ref para o Toast
    const [confirmacao, setConfirmacao] = useState('')
    const [editarSenha, setEditarSenha] = useState(false)
    const [usuario, setUsuario] = useState(
        {
            idempresa : dataEmpresa.idempresa,
            idusuario : props.edicao.idusuario,
            nomeCompleto : "",
            email : "",
            senha : "",
            acessoClientes : "f",
            inclusaoClientes : "f",
            edicaoClientes : "f",
            exclusaoClientes : "f",
            acessoCollector : "f",
            collectorMonitorToner : "f",
            inclusaoCollector : "f",
            edicaoCollector : "f",
            exclusaoCollector : "f",
            acessoDcas : "f",
            inclusaoDcas : "f",
            edicaoDcas : "f",
            exclusaoDcas : "f",
            acessoEquipamentos : "f",
            equipamentosDetalhes : "f",
            equipamentosAtivacao : "f",
            equipamentosDesativacao : "f",
            equipamentosHabilitarToner : "f",
            relatorios : "f",
            idrevenda : dataEmpresa.idrevenda,
            ativo : "f"
        }
    )

    useEffect(()=>{
        if(props.edicao.idusuario){
            setUsuario(prevUser=>({
                    ...prevUser, 
                    idusuario : props.edicao.idusuario,
                    nomeCompleto : edicao.nomecompleto, 
                    email : edicao.email,  
                    acessoClientes : edicao.clientes, 
                    inclusaoClientes : edicao.clientesinclusao, 
                    edicaoClientes : edicao.clientesedicao, 
                    exclusaoClientes : edicao.clientesexclusao, 
                    acessoCollector : edicao.collector, 
                    collectorMonitorToner : edicao.collectormonitorartoner, 
                    inclusaoCollector : edicao.collectorinclusao, 
                    edicaoCollector : edicao.collectoredicao, 
                    exclusaoCollector : edicao.collectorexcluxao, 
                    acessoDcas : edicao.dcas, 
                    inclusaoDcas : edicao.dcasinclusao, 
                    edicaoDcas : edicao.dcasedicao, 
                    exclusaoDcas : edicao.dcasexclusao, 
                    acessoEquipamentos : edicao.equipametos, 
                    equipamentosDetalhes : edicao.equipamentosdetalhes, 
                    equipamentosAtivacao : edicao.equipamentosativacao, 
                    equipamentosDesativacao : edicao.equipamentosdesativacao, 
                    equipamentosHabilitarToner : edicao.equipamentoshabilitartoner, 
                    relatorios : edicao.relatorios
                }))
        }else{
            setUsuario({
            idempresa : dataEmpresa.idempresa,
            idusuario : props.edicao.idusuario,
            nomeCompleto : "",
            email : "",
            senha : "",
            acessoClientes : "f",
            inclusaoClientes : "f",
            edicaoClientes : "f",
            exclusaoClientes : "f",
            acessoCollector : "f",
            collectorMonitorToner : "f",
            inclusaoCollector : "f",
            edicaoCollector : "f",
            exclusaoCollector : "f",
            acessoDcas : "f",
            inclusaoDcas : "f",
            edicaoDcas : "f",
            exclusaoDcas : "f",
            acessoEquipamentos : "f",
            equipamentosDetalhes : "f",
            equipamentosAtivacao : "f",
            equipamentosDesativacao : "f",
            equipamentosHabilitarToner : "f",
            relatorios : "f",
            idrevenda : dataEmpresa.idrevenda,
            ativo : "f"
        })
        }
        
    }, [props.edicao.idusuario])


    useEffect(()=>{
        if(!editarSenha){
            setUsuario(prevState => ({
                ...prevState,
                senha: ''
            }));
            setConfirmacao('')
        }
    }, [editarSenha])


    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };
   const insertEmpresa = () =>{

           const dataUser  = { ...usuario, senha: md5(usuario.senha)}


           props.Conexao.post('usuariosController/insertUsuarioRevenda', 
               { ...dataUser})
           .then(response => {
   
               if (response.status === 200 && response.data.status === 'OK') {
                   setVisible(false)
                   showMessageToast('success', "Registro inserido com sucesso !");                
                   props.updateData(response.data.payload, 'insert');
                  // setEmpresa([])
                   
               } else {
   
                   showMessageToast('warn', "Não foi possível cadastrar empresa");
   
               }
   
             //  props.setLoading(false);
               
           }).catch(error => {
               showMessageToast('error', "Erro ao inserir registro");
              // props.setLoading(false);
           });
   
       }

       const updateUsuarioRevenda = () =>{
 
           const dataUser  = { ...usuario}
           

           props.Conexao.post('usuariosController/updateUsuarioRevenda', 
               { ...dataUser, editarSenhaUsuario : editarSenha ? 't' : 'f'})
           .then(response => {
   
               if (response.status === 200 && response.data.status === 'OK') {
                   setVisible(false)
                   showMessageToast('success', "Registro inserido com sucesso !");                
                   props.updateData(dataUser, 'update');
                  // setEmpresa([])
                   
               } else {
   
                   showMessageToast('warn', "Não foi possível cadastrar empresa");
   
               }
   
             //  props.setLoading(false);
               
           }).catch(error => {
               showMessageToast('error', "Erro ao inserir registro");
              // props.setLoading(false);
           });
   
       }

       const validateFields = () => {
        let newErrors = {};
    
      
    
        setErrors(newErrors);
    
        return Object.keys(newErrors).length === 0; // Retorna true se não houver erros
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUsuario(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const insertUsuario = () =>{
        const usuarioTemp = { ...usuario, senha: md5(usuario.senha) };
        console.log(usuarioTemp)
    
    }
   

    return (
        <div >
            <Button 
                onClick={() => {   
                    setUsuario({
                        idempresa : dataEmpresa.idempresa,
                        nomeCompleto : "",
                        email : "",
                        senha : "",
                        acessoClientes : "f",
                        inclusaoClientes : "f",
                        edicaoClientes : "f",
                        exclusaoClientes : "f",
                        acessoCollector : "f",
                        collectorMonitorToner : "f",
                        inclusaoCollector : "f",
                        edicaoCollector : "f",
                        exclusaoCollector : "f",
                        acessoDcas : "f",
                        inclusaoDcas : "f",
                        edicaoDcas : "f",
                        exclusaoDcas : "f",
                        acessoEquipamentos : "f",
                        equipamentosDetalhes : "f",
                        equipamentosAtivacao : "f",
                        equipamentosDesativacao : "f",
                        equipamentosHabilitarToner : "f",
                        relatorios : "f",
                        idrevenda : dataEmpresa.idrevenda,
                        ativo : "f"
                    })    
                    setConfirmacao('')       
                    setVisible(true)
                }}
                icon="pi pi-plus" 
                className= "p-button-primary p-button-sm" 
                tooltip="Inserir um novo cliente" tooltipOptions={{ position: 'bottom' }}
            /> 
            
            <Dialog
                header="Cadastro de Novo Usuário"
                visible={visible}                
                blockScroll={false} 
                style={{ width: '30vw' }} // Largura padrão
                breakpoints={{ '960px': '30vw', '720px': '90vw' }} // Ajuste para telas menores
                onHide={() => setVisible(false)}
            >
                {/* Opção de Pessoa Jurídica ou Física */}
               

                {/* Formulário em Grid Responsivo */}
                <div className="grid mt-2">
                    {/* CPF/CNPJ */}
                    <div className="col-12 md:col-12">
                        <label htmlFor="documento">Nome Completo</label>
                        
                        <>
                            <InputText
                                value={usuario.nomeCompleto}
                                onChange={handleChange}
                                name="nomeCompleto"
                                className="w-full mt-2"

                            />
                            <small className="p-error">{errors.cnpj}</small>
                        </>
                               
                    </div>

                    {/* RG/Inscrição Estadual */}
                    <div className="col-12 md:col-12">
                        <label htmlFor="inscEstadual">Email</label>
                        <InputTextEmail
                            value={usuario.email}
                            onChange={handleChange}
                            name="email"
                            className="w-full mt-2"
                        />
                    </div>
                    {
                        props.edicao.idusuario ? 
                    
                    <div className="col-12 md:col-12 ">                                      
                        <Checkbox
                            checked ={editarSenha}  onClick={()=>{setEditarSenha(!editarSenha)}}
                        />
                        <label htmlFor="razaoSocial" className="ml-2 text-small">Alterar Senha</label>
                    
                    </div>
                    : 
                    null}

                    {/* Razão Social */}
                    <div className="col-12 md:col-6 ">
                        <label htmlFor="razaoSocial">Senha</label>
              
                        <Password
                            style={{ width: '100%!important' }}
                            disabled ={!editarSenha && props.edicao.idusuario}
                            value={usuario.senha}
                            onChange={handleChange}
                            name="senha"
                            className="w-full mt-2"
                            inputClassName="w-full"
                        />
                    
                    </div>

                    <div className="col-12 md:col-6">
                        <label htmlFor="nomeFantasia">Confirmação</label>
                        <>
                        <Password
                            style={{ width: '100%' }}
                            value={confirmacao}
                            disabled ={!editarSenha && props.edicao.idusuario}
                            onChange={(e)=>setConfirmacao(e.target.value)}
                            name="nomeFantasia"
                            className="w-full mt-2"
                            inputClassName="w-full"
                            onBlur={()=>{
                                if(confirmacao !== usuario.senha){
                                    showMessageToast('error', "A senha e a confirmação não são iguais!");
                                }
                            }}
                        />
                         <small className="p-error">{errors.nomeFantasia}</small>
                         </>
                    </div>
                </div>
               
                <div style={{textAlign : 'center', paddingTop : '20px', paddingBottom : '20px'}}>
                    <label className="text-large">Permissões Gerais</label>
                </div>

                <table style={{width : '100%', padding : '5px'}}>
                    <tr >
                        <td align="center"></td>
                        <td align="center"  className="text-small" style={{paddingBottom : '10px',}}>Consultar</td>
                        <td align="center"  className="text-small" style={{paddingBottom : '10px',}}>Incluir</td>
                        <td align="center"  className="text-small" style={{paddingBottom : '10px',}}>Alterar</td>
                        <td align="center"  className="text-small" style={{paddingBottom : '10px',}}>Excluir</td>
                        <td align="center"  className="text-small" style={{paddingBottom : '10px',}}>Monitorar</td>
                    </tr>

                    <tr>
                        <td className="text-small" >Clientes</td>
                        <td align="center">
                            <Checkbox checked={usuario.acessoClientes === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, acessoClientes : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center">
                            <Checkbox checked={usuario.inclusaoClientes === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, inclusaoClientes : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center">
                            <Checkbox checked={usuario.edicaoClientes === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, edicaoClientes : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center">
                            <Checkbox checked={usuario.exclusaoClientes === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, exclusaoClientes : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"></td>
                    </tr>

                    <tr>
                        <td className="text-small">Licenças</td>
                        <td align="center"><Checkbox checked={usuario.acessoCollector === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, acessoCollector : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.inclusaoCollector === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, inclusaoCollector : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.edicaoCollector === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, edicaoCollector : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.exclusaoCollector === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, exclusaoCollector : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.collectorMonitorToner === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, collectorMonitorToner : e.target.checked ? 't' : 'f'}))}/></td>
                    </tr>

                    <tr>
                        <td className="text-small">DCA's</td>
                        <td align="center"><Checkbox checked={usuario.acessoDcas === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, acessoDcas : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.inclusaoDcas === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, inclusaoDcas : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.edicaoDcas === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, edicaoDcas : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.exclusaoDcas === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, exclusaoDcas : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"></td>
                    </tr>
                    <tr>
                        <td className="text-small">Coletas</td>
                        <td align="center"><Checkbox checked={usuario.acessoEquipamentos === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, acessoEquipamentos : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.equipamentosDetalhes === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, equipamentosDetalhes : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.equipamentosAtivacao === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, equipamentosAtivacao : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.equipamentosDesativacao === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, equipamentosDesativacao : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"><Checkbox checked={usuario.equipamentosHabilitarToner === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, equipamentosHabilitarToner : e.target.checked ? 't' : 'f'}))}/></td>
                    </tr>
                    <tr>
                        <td className="text-small">Relatórios</td>
                        <td align="center"><Checkbox checked={usuario.relatorios === 't'} onChange={(e)=>setUsuario(prevUser=>({...prevUser, relatorios : e.target.checked ? 't' : 'f'}))}/></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                        <td align="center"></td>
                    </tr>
                </table>
                <br/>
                

                

              

                {/* Botão de Enviar */}
                <div className="mt-4 flex justify-content-end mt-2">
                    <Button disabled={props.loading} severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                         confirmDialog({
                            message: 'Deseja cancelar?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {setVisible(false)}
                        });
                    }} />
                    <Button disabled={props.loading} severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {
                        if(confirmacao !== usuario.senha){
                            showMessageToast('error', "A senha e a confirmação não são iguais!");
                            return
                        }
                         if(!validateFields()){
                            showMessageToast("warn", "Preencha todos os campos obrigatórios.");
                            return
                        }
                         confirmDialog({
                            message: 'Confirma a inclusão desse novo usuário?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {
                                if(props.edicao && props.edicao.idusuario){
                                    updateUsuarioRevenda()
                                }else{
                                    insertEmpresa()
                                }
                               
                            } 
                        });
                    }} />
                </div>
            </Dialog>
            <Toast ref={toast} />
        </div>
    );
}
